import {
  WSElement,
  WSSectionToolbar,
  WSCard
} from "@wingspanhq/fe-component-library";
import { IWorkLog } from "@wingspanhq/payments/dist/interfaces";
import React, { useMemo } from "react";
import { Steps, StepItem } from "../../../shared/components/Steps";

type Props = {
  workLog?: IWorkLog;
  shimmer?: boolean;
};

export const WorkLogStatusStepperPayerView: React.FC<Props> = props => {
  const steps: StepItem[] = useMemo(() => {
    const hasInvoice = !!props.workLog?.invoiceId;

    return [
      {
        title: "In-progress",
        status: hasInvoice ? "Complete" : "Active"
      },
      {
        title: "Submitted",
        status: hasInvoice ? "Complete" : "Pending"
      }
    ];
  }, [props.workLog?.invoiceId]);

  return (
    <WSElement>
      <WSSectionToolbar title="Work log steps" />
      <WSCard shimmer={props.shimmer}>
        <Steps steps={steps} />
      </WSCard>
    </WSElement>
  );
};
